/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable react/static-property-placement */
/* eslint-disable react/sort-comp */
/* eslint-disable no-param-reassign */
import Axios from 'axios';
import Cookies from 'js-cookie';
import React from 'react';
import Visibility from 'react-visibility-sensor';

import { convertMetricToSnowPlowClickTracker } from '../SnowPlow/SnowPlowClickTracker';
import { convertMetricToSnowPlowImpressionTracker } from '../SnowPlow/SnowPlowImpressionViewTracker';

export default class VisibilityPixel extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            hasFired: false,
        };
    }

    onVisChange(isVis) {
        const { hasFired } = this.state;
        if (isVis && !hasFired) {
            this.setState({ hasFired: true });
            const { visibilityCallback, metrics } = this.props;
            if (visibilityCallback) visibilityCallback();

            if (!metrics) {
                return;
            }

            if (metrics.snowPlow) {
                convertMetricToSnowPlowImpressionTracker(metrics.snowPlow);
                delete metrics.snowPlow;
            }
            metrics.type = 'pixel';

            EmitMetric(metrics, 'pixel');
        }
    }

    static setLastActionParams = (lac, lat) => {
        const trackingPropsHsh = getTrackingPropsCookie() || {};

        trackingPropsHsh.last_action_category = lac;
        trackingPropsHsh.last_action_type = lat;

        Cookies.set('TRACKING_PROPS', `j:${JSON.stringify(trackingPropsHsh)}`, {
            expires: 1 / 12, // 2 hours
            sameSite: 'None',
            secure: true,
        });
    };

    render() {
        return (
            <div style={{ width: '1px', height: '1px' }}>
                <Visibility onChange={(isVis) => this.onVisChange(isVis)}>
                    <div style={{ width: '1px', height: '1px' }} />
                </Visibility>
            </div>
        );
    }
}

const buildMetrics = (metrics) => {
    const oringalTrackingData = getTrackingPropsCookie();
    const FGBID = getFGBTrackingCookie();
    const trackingData = { ...oringalTrackingData, ...metrics };
    trackingData.url = window.location.pathname;
    const url = new URL(window.location);

    if (FGBID) trackingData.fgb_id = FGBID;

    if (url.searchParams.get('utm_source')) {
        trackingData.utmSource = url.searchParams.get('utm_source');
        trackingData.utm_source = url.searchParams.get('utm_source');
    }

    if (url.searchParams.get('utm_campaign')) {
        trackingData.utmCampaign = url.searchParams.get('utm_campaign');
        trackingData.utm_campaign = url.searchParams.get('utm_campaign');
    }

    if (url.searchParams.get('utm_medium')) {
        trackingData.utmMedium = url.searchParams.get('utm_medium');
        trackingData.utm_medium = url.searchParams.get('utm_medium');
    }

    if (url.searchParams.get('LAT')) {
        trackingData.last_action_type = url.searchParams.get('LAT');
    }

    if (url.searchParams.get('LAC')) {
        trackingData.last_action_category = url.searchParams.get('LAC');
    }

    const metricsString = JSON.stringify(trackingData);
    return encodeURIComponent(metricsString);
};

const getPageMetrics = () => {
    let metricsData = { source: 'frontend' };
    if (
        window
        && window.globalPageData
        && window.globalPageData.analytics
        && window.globalPageData.analytics.metrics
    ) {
        metricsData = window.globalPageData.analytics.metrics;
    }
    return metricsData;
};

const getMetricData = (metrics) => {
    const fullMetrics = { ...getPageMetrics(), ...metrics };
    return fullMetrics;
};

export const EmitPage = (metrics = {}, frontendRoutingEnabled) => {
    if (!window || (window.pageMetricsFired === 1 && !frontendRoutingEnabled)) {
        return;
    }
    if (window) {
        window.pageMetricsFired = 1;
    }
    const pageMetrics = buildMetrics(getMetricData(metrics), 'page');
    try {
        Axios.get(`/_m/page?metrics=${pageMetrics}`);
    } catch (e) {
        window.pageMetricsFired = 1;
    }
};

export const EmitMetric = (metrics = {}) => {
    if (metrics.snowPlow && metrics.snowPlow?.click) {
        convertMetricToSnowPlowClickTracker(metrics.snowPlow);
        delete metrics.snowPlow;
    }

    Axios.get(
        `/_m/emit?metrics=${buildMetrics(getMetricData(metrics), 'emit')}`
    );
};

export const getTrackingPropsCookie = () => {
    const trackingProps = Cookies.get('TRACKING_PROPS');

    return trackingProps ? JSON.parse(trackingProps.split('j:')[1]) : null;
};

export const getFGBTrackingCookie = () => Cookies.get('FGB_ID');

export const getValueFromTrackingProps = (key) => {
    const trackingPropsHsh = getTrackingPropsCookie();

    return trackingPropsHsh ? trackingPropsHsh[key] : null;
};
